import { DataBean } from "../DataBean";

export class Certifications extends DataBean {


    public async getCertificationsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getCertificationsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getCertificationsAccountReport(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("TalentERP", "com.advantage.shared.Report_getCertificationsAccountReport_Number_Number_java.util.Map", [page,Rows,props]);
    }

}